<form [formGroup]="step2">
  <ng-template matStepLabel>STEP 2</ng-template>
  <div mat-dialog-content>
    <mat-form-field fxFill appearance="fill">
      <mat-label>Sheet {{ data }}</mat-label>
      <input matInput id="name" formControlName="name" type="text" placeholder="Enter the name of the File" />
    </mat-form-field>
    <mat-form-field fxFill appearance="fill">
      <mat-label>Target table</mat-label>
      <input matInput id="targetName" formControlName="targetName" type="text" placeholder="Enter the name of Table" />
    </mat-form-field>

    <div class="part2-Formulaire">
      <mat-form-field appearance="fill">
        <mat-label>Connection DB</mat-label>
        <mat-select placeholder="Column type" formControlName="connectionDBId">
          @for (item of connectionDB; track item.id) {
          <mat-option value="{{ item.id }}">{{ item.name !== null ? item.name : 'toto' }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="part3-Formulaire">
        <div class="part3-Formulaire-controller">
          <mat-checkbox formControlName="header">Header</mat-checkbox>
          <mat-checkbox formControlName="append">Append</mat-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="nullable-container">
    <span class="nullable-checkbox">Null</span>
  </div>
  <div class="columns-container" formArrayName="columnCsvList" micScrollBar>
    @for (column of controls; track $index; let i = $index) {
    <div>
      <div [formGroupName]="i" class="column-container">
        <mat-form-field appearance="fill">
          <mat-label>Column</mat-label>
          <input matInput type="text" formControlName="name" [placeholder]="'Column '" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Controller</mat-label>
          <mat-select placeholder="Column type" formControlName="controllerId">
            @for (item of controllers; track item.id) {
            <mat-option value="{{ item.id }}">{{ item.name !== null ? item.name : 'toto' }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-checkbox formControlName="nullable" matTooltip="isNullabe" matTooltipPosition="above"></mat-checkbox>
        <mic-icon (click)="onDeleteColumn(i)" style="cursor: pointer" icon="delete"></mic-icon>
      </div>
    </div>
    }
  </div>
  <div class="icon-body">
    <div class="icon-container">
      <mic-icon (click)="onAddColumn()" style="cursor: pointer" icon="add"></mic-icon>
    </div>
    <div class="icon-container">
      <mic-icon (click)="addSheet()" style="cursor: pointer" icon="description"></mic-icon>
    </div>
  </div>
</form>
